import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/i18n';

Vue.use(VueI18n);

export const LOCALE = {
  PT: 'pt_BR',
  EN: 'en_US',
  ES: 'es_ES',
};

export const getLocaleByNavigatorLanguage = () => {
  let locale = LOCALE.EN;
  const lang = navigator.language;

  if (/pt(-[a-zA-Z]{2})?/.test(lang)) {
    locale = LOCALE.PT;
  } else if (/es(-[a-zA-Z]{2})?/.test(lang)) {
    locale = LOCALE.ES;
  }

  return locale;
};

export const i18n = new VueI18n({
  locale: getLocaleByNavigatorLanguage(),
  fallbackLocale: LOCALE.EN,
  messages,
});

export default ({ app }) => {
  // Set i18n instance on app
  // eslint-disable-next-line no-param-reassign
  app.i18n = i18n;
};
